import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable camelcase */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useUrlParams, Dropdown, useUser, RangePicker } from 'components';
import { showApiError } from 'utils';
import { getAllFranchises } from 'services';
import { tableHeaderContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var filterField = {
  flex: '1 1 180px',
  maxWidth: 240,
  minWidth: 140
};

var ContractReferenceTableHeader = function ContractReferenceTableHeader(_ref) {
  var getData = _ref.getData;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      franchisesList = _useState2[0],
      setFranchisesList = _useState2[1];

  var _useUrlParams = useUrlParams(),
      urlQueryParams = _useUrlParams.urlQueryParams;

  var _useUser = useUser(),
      roleAdditionalData = _useUser.roleAdditionalData;

  var office = urlQueryParams.office,
      franchisee = urlQueryParams.franchisee,
      startDate = urlQueryParams.startDate,
      endDate = urlQueryParams.endDate;
  var queryParams = useRef(urlQueryParams);
  useEffect(function () {
    getData(queryParams.current);
  }, []);
  useEffect(function () {
    fetchFranchises();
  }, []);

  var fetchFranchises = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getAllFranchis, _yield$getAllFranchis2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAllFranchises();

            case 2:
              _yield$getAllFranchis = _context.sent;
              _yield$getAllFranchis2 = _slicedToArray(_yield$getAllFranchis, 2);
              res = _yield$getAllFranchis2[0];
              err = _yield$getAllFranchis2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setFranchisesList(res);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchFranchises() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleOfficeChange = function handleOfficeChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      office: value
    });
    getData(queryParams.current);
  };

  var handleFranchiseeChange = function handleFranchiseeChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      franchisee: value
    });
    getData(queryParams.current);
  };

  var handleDateChange = function handleDateChange(_ref3) {
    var startDate = _ref3.startDate,
        endDate = _ref3.endDate;
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      startDate: startDate,
      endDate: endDate
    });
    getData(queryParams.current);
  };

  return ___EmotionJSX("section", {
    css: tableHeaderContainer
  }, ___EmotionJSX("div", {
    style: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    withSearch: true,
    placeholder: "\u041A\u0440. \u043F\u043E\u0441\u0440\u0435\u0434\u043D\u0438\u043A",
    displayKey: "name",
    uniqueKey: "id",
    value: franchisee,
    options: franchisesList,
    onChange: handleFranchiseeChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.id;
    }
  })), ___EmotionJSX("div", {
    style: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    withSearch: true,
    placeholder: "\u041E\u0444\u0438\u0441",
    displayKey: "name",
    uniqueKey: "id",
    value: office,
    options: roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.offices,
    onChange: handleOfficeChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.id;
    }
  })), ___EmotionJSX("div", {
    style: {
      flex: '0 0 auto'
    }
  }, ___EmotionJSX(RangePicker, {
    startDatePlaceholderText: "\u041E\u0442 \u0434\u0430\u0442\u0430",
    endDatePlaceholderText: "\u0414\u043E \u0434\u0430\u0442\u0430",
    startDate: startDate,
    endDate: endDate,
    onChange: handleDateChange
  })));
};

ContractReferenceTableHeader.propTypes = {
  getData: PropTypes.func
};
export default ContractReferenceTableHeader;